import storage from "./storage.js"
import { isAllowed } from "./allow-origin.js"

export default function acceptShareAuth() {
  window.addEventListener("message", async (event) => {
    console.debug("[auth_ui] message", event.data.type)
    if (!isAllowed(event.origin)) return

    if (event.data.type === "getAuth") {
      await storage.sync()
      event.source.postMessage({
        type: "getAuthResponse",
        payload: storage.items
      }, event.origin)
    } else if (event.data.type === "setAuth") {
      const payload = event.data.payload
      storage.replace(payload)
    }
  })
}
